module.exports = __webpack_public_path__ + "img/contact-img-logo-m.ad8ff5cf.png";